import { Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/Hani Saad/twin-house/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/Hani Saad/twin-house/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/Hani Saad/twin-house/payment/PaymentPage';
const Index = () => {
  return (
    <>
      <Route exact path={`/sun_capital/master-plan/hani-saad/twin-house/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/hani-saad/twin-house/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/hani-saad/twin-house/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
